import { Form } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

const isEmpty = (array: string[]) => array.length === 0

export const MIN_PERCENTAGE_WORKING_HOURS = 1
export const MAX_PERCENTAGE_WORKING_HOURS = 100

export const stepHasErrors = (form: Form) => {
  const workingHourErrors = getWorkingHoursErrors(form)
  return !isEmpty(workingHourErrors)
}

const getWorkingHoursErrors = (form: Form): string[] => {
  if (!form.has('working_hours') || form.has('working_hours_frequency')) return []

  const hoursErrors: string[] = []
  const frequencyErrors: string[] = []

  const hours = form.get('working_hours').value
  const frequency = form.get('working_hours_frequency').value

  if (!hours && !frequency) return []
  if (!hours)
    hoursErrors.push(i18n.t('contract_versions.flows.update.steps.work_hours.errors.missing_hours'))
  if (!frequency) frequencyErrors.push(i18n.t('contract_versions.flows.update.errors.mandatory'))

  form.get('working_hours').setErrors(hoursErrors)
  form.get('working_hours_frequency').setErrors(frequencyErrors)
  return hoursErrors.concat(frequencyErrors)
}

export const constraintToWorkingHoursTimePercentage = (percentage: number): number => {
  percentage = Math.max(MIN_PERCENTAGE_WORKING_HOURS, percentage)
  percentage = Math.min(MAX_PERCENTAGE_WORKING_HOURS, percentage)
  return percentage
}
